import type { WorkflowStageOutDto } from './types';
import { compareFractionalIndex } from 'helpers/sort';

export function sortedStagesByFractionalOrder(
  stages: readonly WorkflowStageOutDto[]
): WorkflowStageOutDto[] {
  return [...stages]
    .filter((stage) => !stage.deleted)
    .sort((a, b) => compareFractionalIndex(a.order, b.order));
}
